import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useBlockCreateModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.createBlockModalState, ...args };
    updateGlobalState({ createBlockModalState: newState });
  };

  return {
    block: state.createBlockModalState.block,
    close: () => {
      if (state.createBlockModalState.block.eventRecord) {
        state.createBlockModalState.block.eventRecord.remove();
      }

      setState({ block: null, eventRecord: null, isOpen: false });
    },
    isOpen: state.createBlockModalState.isOpen,
    open: (block) => setState({ block, isOpen: true }),
  };
}
